import React, { FC, useState, useEffect } from 'react'
import { IonInput } from '@ionic/react'
import { observer } from 'mobx-react'
import './index.scss'
interface IProps {
  defaultValue?: string;
  onChange?: ({ inputValue, valid }: { inputValue: any; valid: any }) => any;
}

const NickNameInput: FC<IProps> = (props) => {
  const {
    defaultValue,
    onChange
  } = props
  const [value, setValue] = useState(defaultValue || '')
  const handleChange = (val: any) => {
    setValue(val)
    onChange && onChange({
      inputValue: val,
      valid: true,
    })
  }
  useEffect(() => {
    setValue(defaultValue || '')
  }, [defaultValue])
  return (
    <div className='mkt-nick-input'>
      <div className='nick-input'>
        <IonInput maxlength={40} value={value} placeholder={i18n.t('mkt.member.enterYourNickname')} onIonChange={e => handleChange(e.detail.value)} clearInput />
      </div>
    </div>
  )
}

export default observer(NickNameInput)
